module.exports = __webpack_public_path__ + "static/media/industrialwaste.2bc4f586.png";